import {
  Users,
  Briefcase,
  Clock,
  Award,
  UserCheck,
  
  Target,
  
} from "lucide-react";

export const RECRUITMENT_TAGS = [
  { label: "Executive Search & Direct Sourcing", icon: Target },
  { label: "Contract & Contingent Workforce", icon: Briefcase },
  { label: "99% Client Satisfaction SLA", icon: Award },
];

export const CORE_OFFERINGS = [
  {
    icon: Users,
    badge: "Direct Sourcing",
    title: "Recruitment Services",
    desc: "Our recruitment services help companies find the best talent for their needs quickly and efficiently. Our team of expert recruiters uses advanced sourcing techniques to identify and attract the most qualified candidates for each position.",
    deliverables: [
      "Executive search & leadership placements",
      "Comprehensive multi-stage technical screening",
      "Culture-fit & background reference audits",
      "Direct pipeline delivery within 48–72 hours",
    ],
  },
  {
    icon: Briefcase,
    badge: "Flexible Workforce",
    title: "Staffing Solutions",
    desc: "We provide companies with flexible and scalable workforce solutions that help them manage their workforce more effectively. From temporary staffing to permanent placement, we offer a range of staffing services that help companies meet their business needs.",
    deliverables: [
      "Contract & project-based engineering teams",
      "Temp-to-hire transition management",
      "Scalable ramp-up for seasonal & surge demands",
      "End-to-end payroll & onboarding compliance",
    ],
  },
];

export const METRIC_HIGHLIGHTS = [
  { label: "Faster Hiring", value: "3.2x", sub: "Accelerated cycle" },
  { label: "Lowest Turn Around Time", value: "< 72h", sub: "Candidate shortlist" },
  { label: "Application to Hire Ratio", value: "4 : 1", sub: "Precision vetting" },
  { label: "Successful Placements", value: "98.4%", sub: "Retention rate" },
];

export const STRATEGIC_PILLARS = [
  {
    icon: Clock,
    title: "Low Turn Around Time",
    desc: "Our advanced recruitment strategies and proprietary talent databases help us find and place the best candidates quickly, without compromising on quality. With Conectify Tech, you get the right talent at the right time.",
  },
  {
    icon: Award,
    title: "High Quality Talent",
    desc: "We have a proven track record of finding and placing high-quality talent that meet the specific technical requirements and team dynamics of our clients. Our rigorous screening ensures top-tier market candidates.",
  },
  {
    icon: UserCheck,
    title: "Personalized Services",
    desc: "We work closely with each of our clients to understand their unique workflows and cultural values. We provide tailored talent strategies and continuous support, guaranteeing the right organizational fit.",
  },
];